import * as React from "react"
import { Textarea } from "@workspace/ui/components/shadcn/textarea"
import { Label } from "@workspace/ui/components/shadcn/label"
import type { FieldDef, FormApi } from "./fieldTypes"
import { normalizeString } from "./fieldUtils"
import { useEnforceTextareaValue } from "./useDomEnforce"
import { cn } from "@workspace/ui/lib/utils"

type Props = {
    def: Extract<FieldDef, { type: "textarea" }>
    form: FormApi
    errorText: string
    helpText: string
    invalid: boolean
    requiredMark: string
}

export function FieldTextarea({
    def,
    form,
    errorText,
    helpText,
    invalid,
    requiredMark,
}: Props) {
    const r = form.register(def.name)
    const value = normalizeString(r.value)
    const textareaRef = React.useRef<HTMLTextAreaElement>(null)

    useEnforceTextareaValue(textareaRef, value)

    return (
        <div className="grid min-w-0">
            <div className="ui-field-header">
                <Label htmlFor={def.name} className="ui-field-label">
                    {def.label}
                    {requiredMark}
                </Label>
                {helpText ? (
                    <span className="ui-field-helptext">{helpText}</span>
                ) : (
                    <span />
                )}
            </div>

            <div
                className={cn(
                    "ui-control flex",
                    invalid && "ui-control-error"
                )}
                style={def.fill ? { height: `${def.fill}px` } : undefined}
            >
                <Textarea
                    ref={textareaRef}
                    id={def.name}
                    name={r.name}
                    value={value}
                    placeholder={def.placeholder}
                    disabled={def.disabled}
                    readOnly={def.readOnly}
                    aria-invalid={invalid ? "true" : "false"}
                    rows={1}
                    className="flex-1 min-h-0 resize-none border-0 bg-transparent shadow-none"
                    onChange={r.onChange}
                    onBlur={r.onBlur}
                />
            </div>

            <div className="ui-field-error">
                {errorText || null}
            </div>
        </div>
    )
}
